import { render, staticRenderFns } from "./ModalInvoiceDraftDetails.vue?vue&type=template&id=1b18d1b4&"
import script from "./ModalInvoiceDraftDetails.vue?vue&type=script&lang=js&"
export * from "./ModalInvoiceDraftDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports